var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaucet(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M11.9,8.7c-0.3,0-0.6,0.2-0.6,0.5v2.1c0,0.3,0.3,0.6,0.6,0.6h5.8v0.5c0,0.3,0.3,0.5,0.6,0.5h0.5v2.2h-3.2 c-0.3,0-0.5,0.2-0.5,0.5v1.1h-3.2v-0.6c0-0.3-0.3-0.5-0.6-0.5H8.1c-0.3,0-0.5,0.2-0.5,0.5v7.5c0,0.3,0.2,0.5,0.5,0.5h3.2 c0.3,0,0.6-0.2,0.6-0.5V23h3.2v1.1c0,0.3,0.2,0.5,0.5,0.5h10.6c0.3,0,0.6-0.2,0.6-0.5V23h1.6c0.9,0,1.6,0.7,1.6,1.6v1.1h-0.6 c-0.3,0-0.5,0.2-0.5,0.5v2.2c0,0.3,0.2,0.5,0.5,0.5h7.5c0.3,0,0.5-0.2,0.5-0.5v-2.2c0-0.3-0.2-0.5-0.5-0.5h-0.5v-2.1 c0-3.8-3.1-6.9-6.9-6.9c0,0-0.1,0-0.1,0h-2.6v-1.1c0-0.3-0.3-0.5-0.6-0.5H23v-2.2h0.6c0.3,0,0.5-0.2,0.5-0.5v-0.5H30 c0.3,0,0.5-0.3,0.5-0.6V9.2c0-0.3-0.2-0.5-0.5-0.5h-5.9V8.1c0-0.3-0.2-0.5-0.5-0.5h-5.3c-0.3,0-0.6,0.2-0.6,0.5v0.6H11.9z  M23.1,11.9h-4.3V8.7h4.3V11.9z M22,15h-2.1v-2.1H22V15z M11.9,22v-4.3h3.2V22H11.9z M16.1,23.6v-7.5h9.6v7.5H16.1z M35.3,23.4 c0,0.1,0,0.1,0,0.2v2.1H31v-1.1c0-1.4-1.2-2.6-2.6-2.6h-1.6v-4.3h2.6C32.6,17.6,35.2,20.2,35.3,23.4z M24.1,9.7h5.3v1.1h-5.3V9.7z  M17.7,9.7v1.1h-5.3V9.7H17.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.8,
    y: 8.7,
    fill: "#A1A1A1",
    width: 4.3,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.1,
    y: 9.7,
    fill: "#A1A1A1",
    width: 5.3,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.4,
    y: 9.7,
    fill: "#A1A1A1",
    width: 5.3,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.9,
    y: 12.9,
    fill: "#C9C9C9",
    width: 2.1,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.9,
    y: 17.7,
    fill: "#C9C9C9",
    width: 3.2,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1,
    y: 16.1,
    fill: "#C9C9C9",
    width: 9.6,
    height: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M26.8,17.7V22h1.6c1.4,0,2.6,1.2,2.6,2.6v1.1h4.3v-2.1c0-0.1,0-0.1,0-0.2c-0.1-3.2-2.7-5.8-5.9-5.7H26.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M33.6,30.2L33.2,30l-0.5,0.2c-0.3,0.5-2.2,3.3-2.2,4.6c0.3,1.5,1.7,2.4,3.2,2.1c1.1-0.2,1.9-1.1,2.1-2.1 C35.8,33.5,34,30.7,33.6,30.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaucet);
export default __webpack_public_path__ + "static/media/faucet.5375944337698b0af3722474d38fda76.svg";
export { ForwardRef as ReactComponent };